import { render } from "./PublicViewsPage.vue?vue&type=template&id=ef384ee2&scoped=true"
import script from "./PublicViewsPage.vue?vue&type=script&lang=js"
export * from "./PublicViewsPage.vue?vue&type=script&lang=js"

import "./PublicViewsPage.vue?vue&type=style&index=0&id=ef384ee2&scoped=true&lang=css"
import "./PublicViewsPage.vue?vue&type=style&index=1&id=ef384ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef384ee2"]])

export default __exports__